// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_6d-4";
export var collapsed = "_6d-1";
export var headerBar = "_6d-0";
export var leftHeaderContent = "_6d-3";
export var subjectContainer = "_6d-2";